import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs, orderBy, Timestamp } from 'firebase/firestore';
import { db } from '../../firebase';
import { useAuth } from '../../AuthContext';
import '../Dashboard.css';
import '../../components/MealTile.css';
import welcomePhoto from '../../assets/welcomePhoto.png';
import HostAccessModal from '../../components/HostAccessModal';
import MealCardList from '../../components/MealCardList';

const HostDashboard = () => {
  const { currentUser, isHost } = useAuth();
  const navigate = useNavigate();
  const [hostedMeals, setHostedMeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAccessModal, setShowAccessModal] = useState(false);

  useEffect(() => {
    const fetchHostedMeals = async () => {
      if (!currentUser) return;

      try {
        const mealsQuery = query(
          collection(db, 'meals'),
          where('hostId', '==', currentUser.uid),
          where('status', '==', 'active'),
          where('dateTime', '>=', Timestamp.now()),
          orderBy('dateTime', 'asc')
        );
        const querySnapshot = await getDocs(mealsQuery);
        const meals = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setHostedMeals(meals);
      } catch (err) {
        console.error('Error fetching hosted meals:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchHostedMeals();
  }, [currentUser]);

  const handleCreateListing = () => {
    if (isHost) {
      navigate('/create-listing');
    } else {
      setShowAccessModal(true);
    }
  };

  const handleAccessGranted = () => {
    navigate('/create-listing');
  };

  if (!currentUser || loading) {
    return (
      <div className="dashboard-container">
        <p className="dashboard-loading">Loading...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <img
        src={welcomePhoto}
        alt="Welcome"
        className="dashboard-image"
      />

      <div className="dashboard-card">
        <div className="meals-tile">
          <h2 className="meals-tile-title">Your Hosted Meals</h2>

          <MealCardList
            meals={hostedMeals}
            onSelect={(meal) => navigate(`/meal-summary/${meal.id}`)}
            emptyMessage="You haven't hosted any meals yet."
          />
        </div>

        <button className="create-listing-button" onClick={handleCreateListing}>
          Create Listing
        </button>
      </div>

      <HostAccessModal
        isOpen={showAccessModal}
        onClose={() => setShowAccessModal(false)}
        onSuccess={handleAccessGranted}
      />
    </div>
  );
};

export default HostDashboard;
